import {Grid, MenuItem, TextField} from "@mui/material";
import classNames from "classnames";
import _ from "lodash";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import React from "react";

const CompanyEditField = ({name, modelName, required, canEdit, items, value, onChange, currentEdit, model, onSaveClick, onEditClick, errorMessage, disabled, multiple = false, t, multiline, rows = 4}) => {

    const handleEditPress = () => {
        onEditClick(name);
    }

    const handleSavePress = () => {
        onSaveClick(modelName, model[name]);
    }

    const handleOnChange = (value) => {
        onChange(name, value);
    }
    
    return (
        <>
            <Grid item md={3} className="fk-label">
                <label htmlFor={name}>{`${t(name)}${(required ? '*' : '')}`}</label>
            </Grid>
            <Grid item md={8} className={
                classNames(
                    'fk-input-container',
                    {
                        'edit-mode': canEdit,
                        'has-error': !!errorMessage,
                    }
                )
            }>
                <TextField
                    fullWidth
                    select={!!items}
                    multiline={multiline}
                    rows={rows}
                    disabled={disabled}
                    className="fk-input"
                    placeholder={t(`${name}Placeholder`)}
                    helperText={errorMessage?.error}
                    value={value}
                    onChange={(event) => handleOnChange(event.target.value)}
                    SelectProps={{
                        multiple: multiple,
                    }}
                >
                    {items && items.map(({value, text}, index) => {
                        const sectorData = (name === 'allSectors') ? _.find(model.sectorsData, (data) => data.sectorId === value) : null;

                        return (
                            <MenuItem key={index} value={value} disabled={!!(sectorData?.reportsDraftsIncludedAmount)} className={sectorData?.reportsDraftsIncludedAmount ? '--have-complains' : ''}>
                                {text}
                            </MenuItem>
                        )
                    })}
                </TextField>
            </Grid>
            {canEdit ?
                <Grid item md={1}>
                    {name !== currentEdit
                        ? <button
                            className="fk-edit-button"
                            onClick={handleEditPress}
                        >
                            <EditIcon />
                        </button>
                        : <button
                            className="fk-edit-button"
                            onClick={handleSavePress}
                        >
                            <SaveIcon />
                        </button>
                    }
                </Grid>
                : <Grid item md={1} />
            }
        </>
    )
}

export default CompanyEditField;